import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    height: "100%",
    paddingBottom: theme.spacings.xs,
  },
  variants: {
    variant: {
      default: {
        gap: theme.spacings.xl,
      },
      sideContent: {
        gap: theme.spacings.l,
      },
      compact: {
        gap: theme.spacings.m,
      },
    },
  },
});

export const agentMessageStyle = recipe({
  base: {},
  variants: {
    variant: {
      default: {
        // width: "80%",
      },
      sideContent: {
        // width: "90%",
      },
      compact: {
        // width: "90%",
      },
    },
  },
});

export const userMessageStyle = recipe({
  base: {
    maxWidth: "60%",
    minWidth: rem(100),
  },
  variants: {
    variant: {
      default: {},
      sideContent: {
        maxWidth: `calc(100% - ${theme.spacings.m})`,
      },
      compact: {
        maxWidth: `calc(100% - ${theme.spacings.m})`,
      },
    },
  },
});

export const messageContainerStyle = recipe({
  base: {
    position: "relative",
  },
  variants: {
    apply: {
      true: {
        ":before": {
          content: "''",
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: `calc(var(--container-height) - ${theme.spacings.m})`,
          maxHeight: "100dvh",
          pointerEvents: "none",
        },
      },
    },
  },
});
